"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LINEA_NO_TRIBUTA_ID = exports.UNIDAD_OTRA_ID = void 0;
exports.esUnidadOtra = esUnidadOtra;
/**
 * Structural institutional records seeded in the database with fixed, stable ids
 * that must never change or be renamed. Shared across web and API.
 *
 * - `UNIDAD_OTRA_ID`: the "Otra" unit (`unidad.id_unidad = 33`, `id_macrounidad`
 *   is NULL). Assigned to researchers that do not belong to a real academic
 *   unit (e.g. some directivos and funcionarios). It does NOT tribute research
 *   lines.
 * - `LINEA_NO_TRIBUTA_ID`: the "No Tributa" line (`linea_investigacion.id_linea = 99`,
 *   `id_unidad` is NULL). A transversal, publication-only attribution line, like
 *   the pre-existing transversal line: it exists so a publication can be tagged
 *   when it does not tribute to any real research line.
 *
 * Rule: a researcher in the "Otra" unit can ONLY use "No Tributa" as a
 * publication line (not the regular transversal lines) and has no research
 * lines of their own.
 */
exports.UNIDAD_OTRA_ID = 33;
exports.LINEA_NO_TRIBUTA_ID = 99;
/** True when the unit does not tribute research lines (the "Otra" unit). */
function esUnidadOtra(idUnidad) {
    return idUnidad === exports.UNIDAD_OTRA_ID;
}
